import { render } from "./Places.svg?vue&type=template&id=142053ce"
const script = {}
script.render = render

export default script